import {NgModule} from "@angular/core";
import {SpørreundersøkelseRedigerDialogKomponentAvhengigheter} from "./modale/spørreundersøkelse-rediger-dialog/spørreundersøkelse-rediger-dialog";
import {SpørreundersøkelseOpprettDialogKomponentAvhengigheter} from "./modale/spørreundersøkelse-opprett-dialog/spørreundersøkelse-opprett-dialog";
import {SpørreundersøkelseBesvarelsedialogKomponentAvhengigheter} from "./modale/spørreundersøkelse-besvarelse-dialog/spørreundersøkelse-besvarelse-dialog";
import {SpørreundersøkelseListevisningKomponentAvhengigheter} from "./komponenter/spørreundersøkelse-listevisning/spørreundersøkelse-listevisning";
import {SpørreundersøkelseListeKomponentAvhengigheter} from "./komponenter/spørreundersøkelse-liste/spørreundersøkelse-liste";

@NgModule({
    providers: [
        SpørreundersøkelseListeKomponentAvhengigheter,
        SpørreundersøkelseListevisningKomponentAvhengigheter,
        SpørreundersøkelseBesvarelsedialogKomponentAvhengigheter,
        SpørreundersøkelseOpprettDialogKomponentAvhengigheter,
        SpørreundersøkelseRedigerDialogKomponentAvhengigheter,
    ]
})
export class SpørreundersøkelseModul {

}
